<template>
  <div>
    <!-- 修改密码弹框 -->
    <el-dialog
      v-model="isShowDialog"
      custom-class="changePwd"
      title="修改密码"
      @close="resetForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        status-icon
        :rules="rules"
        label-position="left"
      >
        <el-form-item
          label="旧密码"
          :label-width="formLabelWidth"
          prop="oldPassword"
        >
          <el-input
            v-model="ruleForm.oldPassword"
            autocomplete="off"
            show-password
          />
        </el-form-item>

        <el-form-item
          label="新密码"
          :label-width="formLabelWidth"
          prop="newPassword"
          class="newPassword"
        >
          <el-input
            v-model="ruleForm.newPassword"
            autocomplete="off"
            show-password
          />
        </el-form-item>

        <el-form-item
          label="确认 新密码"
          :label-width="formLabelWidth"
          prop="checkPwd"
          class="checkPwd"
        >
          <el-input
            v-model="ruleForm.checkPwd"
            autocomplete="off"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button
          class="cancel-button"
          @click="resetForm('ruleForm')"
        >取消
        </el-button>
        <el-button
          class="confirm-button"
          @click="submitForm('ruleForm')"
        >确定
        </el-button>
      </template>
    </el-dialog>
    <my-dialog
      :dialog-carted="infoDialog"
      :width="390"
      title="提示"
      @confirmOk="infoDialog=false"
    >
      <template #content>
        <div>{{ infoDialogMessage }}</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import { changePassword } from "@api/user";
import MyDialog from "@components/customDialog/MyDialog.vue";
import md5 from "js-md5";
import { mapState } from "vuex";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "ChangePassword",
  components: {
    MyDialog
  },
  props: {
    changePwd: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["closeChangeForm"],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    const validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPwd !== "") {
          this.$refs.ruleForm.validateField("checkPwd");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        checkPwd: "",
        id: ""
      },
      rules: {
        oldPwd: [{ validator: validatePass, trigger: "blur" }],
        newPwd: [{ validator: validatePass1, trigger: "blur" }],
        checkPwd: [{ validator: validatePass2, trigger: "blur" }]
      },
      formLabelWidth: "108px",
      infoDialog: false,
      infoDialogMessage: "",
      isShowDialog: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo"
    })
  },
  watch: {
    changePwd: {
      handler(val) {
        // console.log(val);
        this.isShowDialog = val;
      },
      immediate: true
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { newPassword, oldPassword } = this.ruleForm;
          const form = {
            newPassword: md5(newPassword, 32),
            oldPassword: md5(oldPassword, 32),
            id: this.userInfo.id
          };
          try {
            const { code, msg } = await changePassword(form);
            if (code === 200) {
              this.$refs.ruleForm.resetFields();
              this.$emit("closeChangeForm");
            }
            this.infoDialogMessage = msg;
            this.infoDialog = true;
          } catch (e) {
            showWindowMessage(3, e, this);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("closeChangeForm");
    },
  }
};
</script>

<style scoped lang="scss">
/* 修改密码 */
::v-deep .changePwd.el-dialog {
  width: 368px !important;
  background: #FBFBFB;
  box-shadow: 0 0 6px 0 rgba(69, 69, 69, 0.4);
  border-radius: 10px;
  margin-top: 0 !important;

  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #cccccc;
    height: 50px;
    line-height: 50px;
    margin-left: 25px;
  }

  .el-dialog__title {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    letter-spacing: 4px;
  }

  .el-icon-close:before {
    content: '';
    background: url(../../assets/photos/dialogClose.png) center center no-repeat;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(180deg);
  }

  .el-dialog__body {
    padding: 0;
    font-size: 14px;
    color: #999999;
    overflow: auto;
    margin-left: 25px;
    margin-right: 25px;
  }

  .el-form {
    margin-top: 20px;
  }

  .el-input__inner {
    background: transparent;
    border: 1px solid #666666;
    border-radius: 8px;
    box-shadow: none;
  }

  .el-input__prefix,
  .el-input__suffix {
    color: limegreen;
  }

  .el-button {
    height: 28px;
    margin-left: 25px;
    padding-top: 7px;
  }
}

.dialogSuccess,
.dialogError {
  div {
    font-size: 20px;
    font-weight: 400;
    color: #666666;
  }

  .el-button {
    width: 140px;
    height: 50px;
    border: 1px solid #0c618b;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #0c618b;
  }
}
</style>
